import React, { ChangeEvent, forwardRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import classNames from 'classnames';
import './PhoneNumber.scss';

interface PhoneNumberProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  name: string;
  country?: string;
  onChange?: (value: string, data?: unknown, e?: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export const PhoneNumber = forwardRef<HTMLInputElement, PhoneNumberProps>(
  (
    { label, name, country, required, className = '', value, placeholder, onChange, ...props },
    ref
  ) => {
    const [formattedInput, setFormattedInput] = useState('');

    const handleInputChange = (value: string) => {
      setFormattedInput(value);
      onChange && onChange(value);
    };

    const handleBackspaceKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Backspace') {
        e.preventDefault(); // Prevent the default behavior of the backspace key
        setFormattedInput((initialInput) => {
          const formattedValue = initialInput.slice(0, -1);
          onChange && onChange(formattedValue);
          return formattedValue;
        });
      }
    };

    return (
      <label className={classNames('c-input', 'c-phone-input', className)}>
        {label && <span className='c-input-label'>{`${label} ${required ? '*' : ''}`}</span>}
        <PhoneInput
          value={formattedInput}
          onChange={handleInputChange}
          onKeyDown={handleBackspaceKey}
          country={country || window.lang}
          inputProps={{
            name,           
            placeholder,
            ref,
            className: 'c-input-field',
            ...props,
          }}
        />
      </label>
    );
  }
);
